exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".XrTd39ix-Footer-module-footer{background-color:#fff;border-top-color:#f0f0f0;border-top-style:solid;border-top-width:2px;bottom:0;font-size:.875rem;height:45px;padding-top:10px;position:absolute;width:100%}._3Ylv4MzK-Footer-module-nav-item{display:inline;margin-right:10px}._3Ylv4MzK-Footer-module-nav-item:last-child{margin-right:0}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"footer": "XrTd39ix-Footer-module-footer",
	"nav-item": "_3Ylv4MzK-Footer-module-nav-item",
	"navItem": "_3Ylv4MzK-Footer-module-nav-item"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Footer/Footer.module.scss
// module id = 754
// module chunks = 0